const tutorial = {
  title: "Welcome to XLplanner!",
  description:
    "We will now guide you through a tutorial that will help you get to know our application better and provide you with many valuable tips.",
  go: "Let's go!",
  end: "The end!",

  company: {
    title: "Company",
    subtitle: "Select the Company tab located in the top menu",
    description: "In this tab, you can take the most important actions related to your company.",
    menu: {
      company: "Company",
      employees: "Employees",
      drivers: "Drivers",
      documents: "Documents",
      myCars: "My vehicles",
      insurance: "Insurance",
    },
    details: "On the left side, you will see a menu that allows you to manage your company. Here you can, among other things:",
    features: {
      personalize: "Personalize the appearance of your profile by adding company photos",
      addEmployees: "Add employees who will help you manage orders",
      manageDrivers: "Manage drivers who will carry out transports",
      uploadDocuments: "Upload and verify documents that will allow you to better present your company",
      addCars: "Add vehicles owned by the company and monitor the validity of their insurance",
    },
  },

  wallet: {
    title: "Wallet",
    description: "This is where you can check the status of your subscription",
    menu: {
      subscription: "Subscription",
      invoices: "Invoices",
    },
    details: "In the menu you will find the following options: ",
    details1: "Check the validity of your subscription and renew it",
    details2: "Browse the history of invoices for purchases and download the necessary documents",
  },

  pilot: {
    exchange: {
      title: "Exchange",
      subtitle: "Go to the Exchange tab by selecting it from the top menu",
      description:
        "The Exchange is a place where you can post transport orders and then review offers submitted by Pilots for your orders. You also have the option to announce yourself in the application so that other companies can easily find your profile and contact you directly via chat.",
      menu: {
        exchange: "Exchange",
        pilotOffers: "Pilot offers",
        transports: "Transports",
        archive: "Order archive",
      },
      details: "After expanding the menu, you will have the option to:",
      features: {
        browseOrders: "Browse orders on the exchange",
        submitOffers: "Submit offers for desired orders",
        checkStatus: "Check the current status of orders you are applying for",
        addAnnouncement: "Add your company's offer to the Pilot Announcements list",
        browseArchive: "Browse archived orders",
      },
    },
  },

  driver: {
    exchange: {
      title: "Exchange",
      subtitle: "Go to the Exchange tab by selecting it from the top menu",
      description:
        "The Exchange is a place where you can post transport requests and then review offers submitted by Pilots for your jobs. You can also browse Pilots’ listings yourself and contact them directly via chat.",
      menu: {
        exchange: "Exchange",
        myOffers: "My offers",
        transports: "Transports",
        archive: "Order archive",
      },
      details: "When you expand the menu, you will be able to:",
      features: {
        browseOrders: "Post and browse transport requests on the Exchange",
        submitOffers: "View or submit offers for desired jobs",
        checkStatus: "Check the current status of the jobs you’ve applied for",
        addAnnouncement: "Add your company’s offer to the list of Pilot Listings",
        browseArchive: "Browse archived jobs",
      },
    },
  },

  closeDialog: "Close dialog icon",
  page: {
    oneOfSix: "1/6",
    twoOfSix: "2/6",
    threeOfSix: "3/6",
    fourOfSix: "4/6",
    fiveOfSix: "5/6",
    sixOfSix: "6/6",
  },
};

export default tutorial;
